module.exports = __webpack_public_path__ + "img/child-abuse-min.1426c3ac.jpeg";